import React, { createContext, useContext, useState, useCallback } from "react";
import { getUserRole, getAllowedPages } from "../Services/LocalStorageService";

const PermissionContext = createContext({
  allowedPages: [],
  isAdmin: false,
  canAccess: () => false,        
  refreshPermissions: () => {},
});

export function PermissionProvider({ children }) {
  const [role, setRole] = useState(() => getUserRole());
  const [allowedPages, setAllowedPages] = useState(() => getAllowedPages());

  const refreshPermissions = useCallback(() => {
    setRole(getUserRole());
    setAllowedPages(getAllowedPages());
  }, []);

  const isAdmin = role === "admin";

  const canAccess = useCallback(
    (pageKey) => {
      if (isAdmin) return true;                        
      if (allowedPages.includes("*")) return true;       
      if (!allowedPages || allowedPages.length === 0) return false;  
      return allowedPages.includes(pageKey);             
    },
    [isAdmin, allowedPages]
  );

  return (
    <PermissionContext.Provider
      value={{ allowedPages, isAdmin, canAccess, refreshPermissions, role }}
    >
      {children}
    </PermissionContext.Provider>
  );
}

export function usePermission() {
  return useContext(PermissionContext);
}

export default PermissionContext;